import { useDialog } from '@xemplo/use-dialog';

export type UsePromptDialogProps = Readonly<{
  id: string;
  extended?: boolean;
  systemPrompt?: boolean;
}>;

export const usePromptDialog = (props: UsePromptDialogProps) => {
  const { id, systemPrompt, extended } = props;
  const { dialogRef, ...rest } = useDialog({ closeOnOutsideClick: !systemPrompt });

  return {
    ...rest,
    dialogProps: {
      ref: dialogRef,
      id,
      autoFocus: true,
      className: systemPrompt ? 'system-prompt' : '',
    },
    promptProps: {
      extended,
      systemPrompt,
    },
  };
};
